import { render, staticRenderFns } from "./invoicesMangement.vue?vue&type=template&id=d7925e72&scoped=true&"
import script from "./invoicesMangement.vue?vue&type=script&lang=js&"
export * from "./invoicesMangement.vue?vue&type=script&lang=js&"
import style0 from "./invoicesMangement.vue?vue&type=style&index=0&id=d7925e72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7925e72",
  null
  
)

export default component.exports